export const locales = [
  "en",
  "ko",
  "zh",
  "ru",
  "ka",
  "hi",
  "ar",
  "ja",
  "uk",
  "es",
  "vi",
  "tr",
] as const

export type Locale = (typeof locales)[number]

export const defaultLocale: Locale = "ko"

export const LOCALE_COOKIE = "locale"

export const localeLabels: Record<Locale, string> = {
  en: "English",
  ko: "한국어",
  zh: "中文",
  ru: "Русский",
  ka: "ქართული",
  hi: "हिन्दी",
  ar: "العربية",
  ja: "日本語",
  uk: "Українська",
  es: "Español",
  vi: "Tiếng Việt",
  tr: "Türkçe",
}

export function isLocale(value: string): value is Locale {
  return (locales as readonly string[]).includes(value)
}
